"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Logos = _interopRequireDefault(require("../../img/Logos"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CompanyLogo = _ref => {
  let {
    variant,
    theme,
    department,
    animated,
    animation,
    ...rest
  } = _ref;
  let cn = "";
  if (animated) {
    cn += " animated " + animation;
  }
  const logo = _Logos.default[department][theme].variations['v' + variant];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
    className: cn,
    src: logo,
    alt: "Indigenux company logo",
    ...rest
  });
};
CompanyLogo.propTypes = {
  variant: _propTypes.default.oneOf(['1', '2', '3', '4']).isRequired,
  theme: _propTypes.default.oneOf(['light', 'dark']),
  department: _propTypes.default.oneOf(['unified', 'creative', 'success', 'talent', 'innovate']).isRequired,
  animated: _propTypes.default.bool,
  animation: _propTypes.default.string
};
CompanyLogo.defaultProps = {
  variant: '1',
  theme: 'light',
  department: 'unified',
  animated: false
};
var _default = exports.default = CompanyLogo;